module.exports = __webpack_public_path__ + "b9a9f705a5423bb7be9e8220633c9efe.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/history/fi-2010.png
// module id = 355
// module chunks = 0